module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-form', {
    ref: "scheduleForm"
  }, [_c('condominium-box', {
    attrs: {
      "value": _vm.schedule
    }
  }), _vm._v(" "), (!_vm.scheduleEditing) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    class: {
      'w-49': !_vm.scheduleDone
    },
    attrs: {
      "xs12": "",
      "s6": "",
      "md6": ""
    }
  }, [(!_vm.alteredScheduleSaving) ? [_c('send-email')] : _vm._e()], 2), _vm._v(" "), _c('v-spacer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.scheduleDone),
      expression: "!scheduleDone"
    }]
  }), _vm._v(" "), (!_vm.alteredScheduleSaving) ? _c('v-flex', {
    staticClass: "w-49",
    attrs: {
      "xs12": "",
      "s6": "",
      "md6": ""
    }
  }, [(_vm.schedule.status === 0) ? _c('v-layout', {
    staticClass: "condominium-box mb-3 pt-3 pb-2 pl-3 pr-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('h6', [_vm._v("Visita")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center"
  }, [(!_vm.loadingScheduleActions) ? _c('cancel-warning', [_c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red",
      "disabled": !_vm.schedule.sent
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("event")]), _vm._v("Cancelar agendamento")], 1)], 1) : _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red",
      "disabled": _vm.loadingScheduleActions || !_vm.schedule.sent
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("event")]), _vm._v("Cancelar agendamento")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "color": "green",
      "disabled": _vm.loadingScheduleActions
    },
    on: {
      "click": _vm.finishSchedule
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("done_all")]), _vm._v("Agendamento realizado")], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9452970c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/agendamento/ScheduleModal/ScheduleDetails.vue
// module id = 512
// module chunks = 0 1